// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2VLyS","colMaxWidth":"Table_colMaxWidth__1OK2B"};